<template lang="pug">
  .details-wrapper
    .editing(v-if="editing")
      Validate.name(v-if="editedDevice.deviceType === 'mobile'" v-model="editedDevice.name")
        PTextField(
          name="name"
          v-focus
          label="nome"
        )
      .companies(v-if="editedDevice.deviceType === 'mobile' || !editedDevice.personal" style="margin-top: 30px;")
        PMultiSelect(
          v-model="editingCompanies"
          useCommon="companies/onlyActive"
          labelItem="name"
          :title="$wp('company')"
        )
      Accordion.advanced(:startOpen="true")
        template(slot="heading")
          span.fs-19(style="text-align: center;") configurações avançadas

        template(v-if="editedDevice.deviceType === 'mobile'")
          .check-fake-gps
            PCheckbox(
              label="Ativar proteção extra contra manipulação de GPS (Aplicativo pode apresentar lentidão)"
              v-model="editedDevice.checkFakeGps"
            )
          .check-face
            PCheckbox(
              v-if="showFaceOption"
              label="Ativar detecção de face ao bater ponto (Aplicativo pode apresentar lentidão)"
              v-model="editedDevice.checkFace"
            )
          .accuracy(v-if="editedDevice.checkFace && showFaceAccuracyOption")
            span Escolha o nível de detecção facial
            PRadio(label="rapido" v-model="editedDevice.checkFaceAccuracy" option="0")
            PRadio(label="preciso" v-model="editedDevice.checkFaceAccuracy" option="1")
          .disable-gps
            PCheckbox(
              label="Desativar verificação de GPS"
              v-model="editedDevice.disableGps"
            )
          .insecure-mode
            PCheckbox(
              v-if="showInsecureModeOption"
              label="Permitir registro de ponto em modo de horário interno (Utiliza o horário do aparelho quando não for possível estabelecer comunicação com o servidor. Em casos raros, o horário obtido dessa forma pode ter sido manipulado)"
              v-model="editedDevice.insecureMode"
            )
        template(v-else)
          .recaptcha
            PCheckbox(
              label="Ativar validação por recaptcha"
              v-model="editedDevice.recaptcha"
            )
      .actions-buttons
        PButton(color="info" size="md" @click="saveEditedDevice" title="salvar")
          .icon-bv-icones-disquete
        PButton(color="danger" size="md" @click="editing = false" title="cancelar")
          .icon-bv-icones-nao
    .not-editing(v-else)
      .name
        DBLabel(title="nome" :body="device.name")
      .version
        DBLabel(title="versão" :body="device.appVersion ? device.appVersion : '-'")
      .sync-title(v-if="device.deviceType === 'mobile'" style="margin-top: 30px;")
        span(style="font-weight: bold;") ultimas sincronizações
      .last-synced-audios(v-if="device.deviceType === 'mobile'")
        DBLabel(title="audios" :body="checkIfExists(device.lastSyncedAudios)")
      .last-synced-photos(v-if="device.deviceType === 'mobile'")
        DBLabel(title="fotos" :body="checkIfExists(device.lastSyncedPhotos)")
      .last-synced-timelogs(v-if="device.deviceType === 'mobile'")
        DBLabel(title="sincronizou pontos" :body="checkIfExists(device.lastSyncedTimelogs)")
      .last-synced-employee-routine(v-if="device.deviceType === 'mobile'")
        DBLabel(:title="`atualizou rotina dos ${$wp('employee')}`" :body="checkIfExists(device.lastSyncedEmployeeRoutine)")
      .last-synced-employee-list(v-if="device.deviceType === 'mobile'")
        DBLabel(:title="`atualizou lista dos ${$wp('employee')}`" :body="checkIfExists(device.lastSyncedEmployeeList)")
      .last-synced-timelogs-download(v-if="device.deviceType === 'mobile'")
        DBLabel(title="atualizou pontos em outros dispositivos" :body="checkIfExists(device.lastSyncedTimelogsDownload)")
      .last-synced-dayjourney(v-if="device.deviceType === 'mobile'")
        DBLabel(:title="`horário de trabalho dos ${$wp('employee')}`" :body="checkIfExists(device.lastSyncedDayjourney)")
      .last-synced-wrong-password(v-if="device.deviceType === 'mobile'")
        DBLabel(title="ultima tentativa de senha errada" :body="checkIfExists(device.lastSyncedWrongPassword)")
      .flags
        template(v-if="device.deviceType === 'mobile'")
          .check-fake-gps
            PCheckbox(
              label="Ativar proteção extra contra manipulação de GPS (Aplicativo pode apresentar lentidão)"
              v-model="device.checkFakeGps"
              readonly
            )
          .check-face
            PCheckbox(
              v-if="showFaceOption"
              label="Ativar detecção de face ao bater ponto (Aplicativo pode apresentar lentidão)"
              v-model="device.checkFace"
              readonly
            )
            PRadio(v-if="device.checkFace && showFaceAccuracyOption" label="rapido" v-model="device.checkFaceAccuracy" option="0" disabled)
            PRadio(v-if="device.checkFace && showFaceAccuracyOption" label="preciso" v-model="device.checkFaceAccuracy" option="1" disabled)
          .disable-gps
            PCheckbox(
              label="Desativar verificação de GPS"
              v-model="device.disableGps"
              readonly
            )
          .insecure-mode(v-if="device.deviceType === 'mobile' && showInsecureModeOption")
            PCheckbox(
              label="Permitir registro de ponto em modo de horário interno (Utiliza o horário do aparelho quando não for possível estabelecer comunicação com o servidor. Em casos raros, o horário obtido dessa forma pode ter sido manipulado)"
              v-model="device.insecureMode"
              readonly
            )
        template(v-else)
          .recaptcha
            PCheckbox(
              v-if="!loading"
              label="Ativar validação por recaptcha"
              v-model="device.recaptcha"
              readonly
            )

      .companies(v-if="device.companies" style="margin-top: 30px;")
        PMultiSelect(
          v-model="companies"
          useCommon="companies"
          labelItem="name"
          :title="$wp('company')"
          :displayMode="true"
        )

      .actions-buttons

        PButton(v-if="device.deviceType !== 'mobile' && device.active" color="danger" size="md" @click="approveDevice" title="reprovar")
          .icon-ptt-icons-reprovar

        PButton(v-if="device.deviceType !== 'mobile' && !device.active" color="success" size="md" @click="approveDevice" title="aprovar")
          .icon-ptt-icons-aprovar

        PButton(color="info" size="md" @click="editDevice" title="editar")
          .icon-ptt-icons-lapis

        PButton(color="danger" size="md" @click="removeDevice" :loading="deleting" title="excluir")
          .icon-ptt-icons-excluir
</template>

<script>
import DBLabel from 'src/common/SmartTable/DBLabel'
import { useValidationsMixin } from 'src/common/validations'

export default {
  name: 'Details',
  props: {
    device: {type: Object, required: true},
    loading: {type: Boolean, required: true}
  },
  data () {
    return {
      editing: false,
      editedDevice: {},
      deleting: false,
      companiesData: { selected: [] }
    }
  },
  computed: {
    companies: {
      set (val) { this.companiesData = val },
      get () {
        return {
          selected: this.device.companies
        }
      }
    },
    editingCompanies: {
      set (val) {
        const formatCompanies = c => {
          return {id: c.id, name: c.name}
        }
        this.editedDevice.companies = val.selected.map(formatCompanies)
      },
      get () {
        return {
          selected: this.editedDevice.companies
        }
      }
    },
    version () {
      if (!this.device.appVersion) return ['0', '0', '0', '0']
      return this.device.appVersion
        .replace('v', '')
        .split('.')
    },
    showInsecureModeOption () {
      return this.version[0] > 3 || (this.version[0] === 3 && this.version[1] > 2)
    },
    showFaceAccuracyOption () {
      if (this.version[0] > 2) {
        // omit option of detect face accuracy if the version is older than 3.2.0
        if (this.version[0] > 3 || (this.version[0] === 3 && this.version[1] > 2)) {
          return true
        }
      }
      return false
    },
    showFaceOption () {
      return this.version[0] > 2
    },
    compMan () {
      return this.$store.state.userInfo.compMan
    }
  },
  methods: {
    editDevice () {
      this.editing = true
      this.editedDevice = {...this.device}
    },
    async approveDevice () {
      const params = {
        'fingerprint': this.device.id,
        'kind': 'unique',
        'active': this.device.active
      }

      const result = await this.$API.approveDevices.save(params)
      if ('success' in result.body) {
        this.$swal({type: 'success', text: result.body.success})
        this.$emit('updateTable')
      } else {
        this.$swal({type: 'warning', text: result.body.error})
      }
    },
    async saveEditedDevice () {
      if (this.editedDevice.deviceType === 'pc') {
        try {
          if (!this.editedDevice.personal && this.editedDevice.companies.length < 1) {
            this.$swal({
              type: 'error',
              title: '',
              text: 'Selecione pelo menos um local de trabalho'
            })
            return
          }
          const params = {
            'fingerprint': this.editedDevice.id,
            'comp_man': this.$store.state.userInfo.compMan.id,
            'companies': this.editedDevice.companies,
            'recaptcha': this.editedDevice.recaptcha
          }
          await this.$API.deviceManage.save(params)
          this.$swal({
            type: 'success',
            text: 'Dispositivo atualizado com sucesso'
          })
        } catch (e) {
          console.warn(e)
          this.$swal({
            type: 'error',
            text: e.data && e.data.error ? e.data.error : 'Ocorreu um erro, por favor, tente novamente.'
          })
        }
      } else {
        try {
          if (this.editedDevice.companies.length < 1) {
            this.$swal({
              type: 'error',
              title: '',
              text: 'Selecione pelo menos um local de trabalho'
            })
            return
          }
          const params = {
            'imei': this.editedDevice.imei,
            'imei_id': this.editedDevice.id,
            'comp_man': this.$store.state.userInfo.compMan.id,
            'companies': this.editedDevice.companies,
            'new_imei_name': this.editedDevice.name
          }
          params.disableGps = this.editedDevice.disableGps
          params.checkFakeGps = this.editedDevice.checkFakeGps
          params.checkFace = this.editedDevice.checkFace
          params.insecureMode = this.editedDevice.insecureMode

          if (this.editedDevice.checkFaceAccuracy !== null) {
            params.checkFaceAccuracy = this.editedDevice.checkFaceAccuracy
          }

          await this.$API.deviceManage.save(params)

          this.$swal({
            type: 'success',
            text: 'Dispositivo atualizado com sucesso'
          })
        } catch (error) {
          this.$swal({
            type: 'error',
            text: error.data && error.data.error ? error.data.error : 'Ocorreu um erro, por favor, tente novamente.'
          })
        }
      }
      this.editing = false
      this.$emit('updateTable')
    },
    async removeDevice () {
      this.$swal({
        title: 'Tem certeza?',
        text: 'Deseja descadastrar esse dispostivo?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#28b62c',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then(async () => {
        const params = {'delete': true, comp_man: this.compMan.id}
        if (this.device.deviceType === 'pc') {
          params.fingerprint = this.device.id
        } else {
          params.imei_id = this.device.idCopy || this.device.id
        }
        try {
          const response = await this.$API.deviceManage.save(params)
          if ('success' in response.body) {
            this.$swal({
              type: 'success',
              title: '',
              text: response.body.success
            })
            this.$emit('updateTable')
          }
        } catch (error) {
          this.$swal({
            type: 'warning',
            title: '',
            text: error.body.error
          })
        }
      }, () => {
        this.$swal({
          type: 'success',
          title: 'Cancelado',
          text: ''
        })
      })
    },
    checkIfExists (field) {
      if (field) return field
      return '-'
    }
  },
  mixins: [useValidationsMixin({})],
  components: { DBLabel }
}
</script>

<style lang="scss" scoped>
.details-wrapper {
  height: 100%;
  .not-editing {
    height: 100%;
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto min-content auto auto auto auto auto 1fr;
    grid-template-areas:
      "name version"
      "sync-title sync-title"
      "last-synced-photos last-synced-audios"
      "last-synced-employee-routine last-synced-timelogs"
      "last-synced-timelogs-download last-synced-employee-list"
      "last-synced-wrong-password last-synced-dayjourney"
      "companies companies"
      "flags flags"
      "buttons buttons";

    .name { grid-area: name }
    .version { grid-area: version }
    .sync-title { grid-area: sync-title }
    .last-synced-audios { grid-area: last-synced-audios }
    .last-synced-photos { grid-area: last-synced-photos }
    .last-synced-timelogs { grid-area: last-synced-timelogs }
    .last-synced-employee-routine { grid-area: last-synced-employee-routine }
    .last-synced-employee-list { grid-area: last-synced-employee-list }
    .last-synced-timelogs-download { grid-area: last-synced-timelogs-download }
    .last-synced-dayjourney { grid-area: last-synced-dayjourney }
    .last-synced-wrong-password { grid-area: last-synced-wrong-password }
    .companies { grid-area: companies }
    .flags {
      grid-area: flags;
      .check-face {
        display: flex;
        & > * {
          margin-right: 20px;
        }
      }
    }
    .actions-buttons {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 2px;
      grid-area: buttons;
      justify-self: right;
      align-self: end;
    }
  }
  .editing {
    height: 100%;
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto min-content auto 1fr;
    grid-template-areas:
      "name name"
      "companies companies"
      "advanced advanced"
      "buttons buttons";

    .name { grid-area: name }
    .companies { grid-area: companies }
    .advanced {
      grid-area: advanced;
      margin-top: 30px;

      .accuracy {
        margin: 30px 0;
        width: 30%;
      }
    }
    .actions-buttons {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 2px;
      margin-top: 30px;
      grid-area: buttons;
      justify-self: right;
      align-self: end;
    }
  }
}
</style>
